import { QuoteButton, CallButton, CertLine } from "@/components/site/Cta";
import { MaskLines, Reveal } from "@/components/site/Reveal";
import { LogoMark } from "@/components/site/Logo";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="grain relative overflow-hidden bg-[#050607] py-28 sm:py-40">
    <div className="pointer-events-none absolute bottom-[-55%] left-1/2 h-[900px] w-[900px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(255,196,94,0.45)_0%,rgba(245,166,35,0.15)_40%,transparent_68%)] sun-breathe" />
    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-amber-400/60 to-transparent" />
    <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
      <Reveal className="flex justify-center"><LogoMark className="h-14 w-[72px]" /></Reveal>
      <MaskLines lines={["Ready to take", "control of your energy?"]} className="mt-8 text-[1.8rem] leading-[1.1] sm:text-5xl lg:text-6xl font-semibold uppercase text-white" />
      <Reveal delay={0.15} as="p" className="mx-auto mt-7 max-w-2xl text-base md:text-lg leading-relaxed text-zinc-200">
        Whether you're ready for solar, need your system serviced, or need professional help with an existing system, Solar Energy Doc is ready to help.
      </Reveal>
      <Reveal delay={0.25} className="mt-10 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
        <QuoteButton testId="final-cta-quote">Get a Free Quote</QuoteButton>
        <CallButton testId="final-cta-call">Call Solar Energy Doc</CallButton>
      </Reveal>
      <Reveal delay={0.35}><CertLine className="mt-12" /></Reveal>
    </div>
  </section>
);
